export default "__VITE_ASSET__BppM_G3y__"